// React hook to fetch meetings for a user

import { Meeting } from "@/types/supabase";

import { supabase } from "../lib/supabase";
import { BaseApi } from "./baseApi";

class MeetingApi extends BaseApi<Meeting> {
  async getByUserUuid(userUuid: string): Promise<Meeting[]> {
    const { data, error } = await supabase
      .from("meeting")
      .select("*, mentor:mentor_uuid(uuid, vincer_base_user(name, email))")
      .eq("mentee_uuid", userUuid)
      .order("scheduled_time", { ascending: false });
    if (error) throw error;
    return data || [];
  }
}

export const meetingApi = new MeetingApi("meeting");
